export const MiddleContent = ({children}) => {
    return (
        <div className="middle-content col-6 px-2">
            <div className="border-middle-container rounded">
                {children}         
            </div>
        </div>
    )
}